import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

// Capture invite/recovery action from the URL hash synchronously at module load,
// before the Supabase client's detectSessionInUrl consumes and clears it.
// Supabase appends e.g. `#access_token=...&type=invite` (or type=recovery) to the
// redirect target. We use this to route the user to the Set Password screen.
function readInitialAuthAction() {
  if (typeof window === 'undefined') return null
  const hash = window.location.hash || ''
  const params = new URLSearchParams(hash.replace(/^#/, ''))
  const type = params.get('type')
  if (params.get('error')) return { type: null, error: params.get('error_description') || params.get('error') }
  return { type, error: null }
}

export const initialAuthAction = readInitialAuthAction()

export const supabase = createClient(supabaseUrl, supabaseAnonKey)
